import React, { Component } from "react"
import { Container, Row, Col, Spinner  } from "react-bootstrap"
import { toast } from "react-toastify"
import { Subscription } from "rxjs"
import { CurrentServiceDetails } from "../../../api/OrderResults/CurrentServiceDetails"
import OrderResultRecord from "../../../api/OrderResults/OrderResultModel/OrderResultRecord"
import ServiceDetails from "../../../api/OrderResults/OrderResultModel/ServiceDetails"
import SelectionInboxGridRow from "../../../api/Randoms/SelectionInboxModel/SelectionInboxGridRow"
import { ImplementationTypeGovt, StorageKey } from "../../../config/Constants"
import TestSteps from "../EventDetails/TestSteps"

interface CurrentServiceProps {
  details: OrderResultRecord
}

interface CurrentServiceState {
  data?: ServiceDetails
  loading: boolean
}

export default class CurrentService extends Component<CurrentServiceProps, CurrentServiceState> {
  subscription?: Subscription
  state: CurrentServiceState = { data: undefined, loading:false }
  isOnTrack: boolean = sessionStorage.getItem(StorageKey.ImplementationType) === ImplementationTypeGovt

  componentDidMount() {
    this.setState({ loading: true })
    const details = this.props.details
    this.subscription = CurrentServiceDetails({ TestDetailClinicalID: details.TestDetailClinicalID, TestDetailID: details.TestDetailID }).subscribe(
      (data: ServiceDetails) => this.setState({ data: data, loading: false }),
      (error: string) => {
        this.setState({ loading: false })
        toast.error(error)
      },
      () => this.setState({ loading: false })
    )
  }

  componentWillUnmount() {
    this.subscription && this.subscription.unsubscribe()
  }

  render() {
    if (!this.state.data) {
      return this.state.loading ? <Spinner animation="border" size="sm" /> : <></>
    } else {
    const currentServiceInfo = this.state.data
    const currentRowInfo = this.props.details
    return currentServiceInfo ? (
      <Container className="current-service p-0">
        <Container className="px-4 pb-4 pt-3">
          <Row>
            <Col>
              <h5 className="pt-3 pb-2">
                <span className="text-uppercase">{currentServiceInfo.TestTypeDescription}</span> TEST: {currentServiceInfo.TestReleaseStatusDescription} - {currentServiceInfo.MROResultDescription}
              </h5>
            </Col>
          </Row>
          <Row className="py-1">
            <Col xs={6} md={4}><span className="caption">REASON FOR TEST</span></Col>
            <Col xs={6} md={8}>{currentServiceInfo.TestReasonDescription}</Col>
          </Row>
          <Row className="py-1">
            <Col xs={6} md={4}><span className="caption">SAMPLE TYPE</span></Col>
            <Col xs={6} md={8}>{currentServiceInfo.SampleTypeDescription}</Col>
          </Row>
          <Row className="py-1">
            <Col xs={6} md={4}><span className="caption">PANEL</span></Col>
            <Col xs={6} md={8}>{currentServiceInfo.Panel.Description}</Col>
          </Row>
          <Row className="py-1">
            <Col xs={6} md={4}><span className="caption">FEDERALLY REGULATED</span></Col>
            <Col xs={6} md={8}>{currentServiceInfo.DOT ? "Yes" : "No"}</Col>
          </Row>
          <Row className="py-1">
            <Col xs={6} md={4}><span className="caption">REGULATORY MODE</span></Col>
            <Col xs={6} md={8}>{currentServiceInfo.EventData.RegulatoryModeName}</Col>
          </Row>
        </Container>
        <Container className="px-2 pb-2">
            <TestSteps currentRowInfo={currentRowInfo} currentServiceInfo={currentServiceInfo} isOnTrack={this.isOnTrack}/>
        </Container>
      </Container>
    ) : null
  }
}
}
